import { Module } from 'vuex';

import { RootState, NotificationState } from '../types';
import { api } from '../../plugins/salut-api';
import { ProfileActionKeys } from './profile';

const SET_NOTIFICATION = 'SET_NOTIFICATION';
const SET_LAST_ERROR = 'SET_LAST_ERROR';
const SET_NOTIFICATION_TIMER = 'SET_NOTIFICATION_TIMER';

export const NotificationActionKeys = {
	fetch: 'fetch',
	fetchImmediate: 'fetchImmediate',
	setTimer: 'setTimer',
	clearTimer: 'clearTimer',
};

const initialState: NotificationState = {
	notification: {},
	notificationTimer: undefined,
	lastError: '',
};

const store: Module<NotificationState, RootState> = {
	namespaced: true,

	state: { ...initialState },

	actions: {
		async [NotificationActionKeys.fetchImmediate]({ commit, dispatch }) {
			try {
				commit(SET_NOTIFICATION, await api.fetchNotificationBadges());
				dispatch(
					`profile/${ProfileActionKeys.fetchUnreadInboxMessages}`,
					{},
					{ root: true },
				);
			} catch (error) {
				commit(SET_LAST_ERROR, error);
			}
		},

		[NotificationActionKeys.setTimer]({
			state,
			commit,
			dispatch,
			rootGetters,
		}) {
			dispatch(NotificationActionKeys.clearTimer);
			commit(
				SET_NOTIFICATION_TIMER,
				setInterval(
					() => {
						if (!rootGetters['auth/isAuthenticated']()) {
							// abort if not authenticated
							return dispatch(NotificationActionKeys.clearTimer);
						}
						dispatch(NotificationActionKeys.fetchImmediate);
					},
					5 * 60 * 1000, // 5 mins
				),
			);
		},

		// fetch on a timeout since BE has a caching mechanism
		// and in this case we want to ensure getting the latest values
		[NotificationActionKeys.fetch]({ dispatch, rootGetters }) {
			setTimeout(
				() => {
					if (!rootGetters['auth/isAuthenticated']()) {
						// abort if not authenticated
						return;
					}
					dispatch(NotificationActionKeys.fetchImmediate);
				},
				2000, // 2s - BE cache is invalidated after 1.5s, this allows retrieving latest values
			);
		},

		[NotificationActionKeys.clearTimer]({ state, commit }) {
			if (state.notificationTimer) {
				clearInterval(state.notificationTimer);
				commit(SET_NOTIFICATION_TIMER, undefined);
			}
		},
	},

	mutations: {
		[SET_NOTIFICATION](state, notification) {
			state.notification = notification;
		},

		[SET_LAST_ERROR](state, error) {
			state.lastError = error;
		},

		[SET_NOTIFICATION_TIMER](state, timer?: number) {
			state.notificationTimer = timer;
		},
	},

	getters: {
		notification: state => state.notification,

		contactApplications: getters =>
			getters.notification?.contacts?.applications,

		eventApplications: getters => getters.notification?.events?.applications,

		jobApplications: getters => getters.notification?.jobs?.applications,

		formSubmitted: getters => getters.notification?.forms?.submitted,
		onboardingPendingSteps: getters => {
			return getters.notification?.onboarding?.pendingSteps;
		},
	},
};

export default store;
